import React from "react"
import { Link } from "react-router-dom"
import "./topBar.css"
import Logo from "../../assets/dc-logo.png"
import { Nav, Navbar } from "react-bootstrap"
import { useSelector } from "react-redux"

export const TopBar = () => {
  const { user } = useSelector((state) => state.user)

  return (
    <Navbar variant="dark" expand="md" className="topbar">
      <Navbar.Brand href="/dashboard" className="topbar-brand">
        <img className="logo" src={Logo} alt="logo" />
        <span className="fw-bold">Dented Code Admin Panel</span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="mx-4" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="text-center topbar-nav ms-auto px-5">
          <Link to="/pre-enrolment">Eoi</Link>
          <Link to="/enrol">Enrol</Link>
          <Link to="/leads">Leads</Link>
          <Link to="/setting">Setting</Link>

          {user?.role === "admin" && (
            <>
              <Link to="/blog">Blog</Link>
              <Link to="/course">Course</Link>
              <Link to="/student">Student</Link>
              <Link to="/reviews">Reviews</Link>
              <Link to="/ambassadors">Ambassadors</Link>
              <Link to="/staffs">Staff</Link>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}
